class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.announcementSection = document.querySelector(".section-announcement");
    this.toggles = this.querySelectorAll(".js-announcement-toggle");
    this.detail = this.querySelector(".announcement__detail");

    if (
      this.classList.contains("announcement--has-detail") &&
      this.toggles.length
    ) {
      this.toggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();
          this.toggle();
        });
      });
    }

    this.onBodyClick = this.handleBodyClick.bind(this);
  }

  toggle() {
    if (this.classList.contains("active")) {
      this.classList.remove("active");
      document.body.classList.remove("shadow");
      const scrollY = document.body.style.top;
      document.body.style.top = "";
      document.body.style.position = "";
      window.scrollTo(0, parseInt(scrollY || 0) * -1);
      document.body.removeEventListener("click", this.onBodyClick, {
        passive: true,
      });
      this.announcementSection.style.zIndex = "var(--z-index-announcement)";
    } else {
      this.announcementSection.style.zIndex = "var(--z-index-drawer)";
      this.classList.add("active");
      document.body.classList.add("shadow");
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.position = "fixed";
      document.body.addEventListener("click", this.onBodyClick, {
        passive: true,
      });
    }
  }

  //Body click event to close announcement detail
  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this &&
      !target.closest("announcement-bar") &&
      !target.closest(".announcement__detail")
    ) {
      this.toggle();
    }
  }
}

customElements.define("announcement-bar", AnnouncementBar);

var countDownTimers = [];

function addLeadingZero(timeInput) {
  return ('0' + timeInput.toString()).slice(-2);
}

function timerLoop() {
  var remainingTime, seconds, minutes, hours, days;
  var currentTime = new Date().getTime();
  var thisTimerText;
  for (var i = 0; i < countDownTimers.length; i++) {
    remainingTime = countDownTimers[i][1] - currentTime;

    var seconds = Math.floor((remainingTime / 1000) % 60);
    var minutes = Math.floor((remainingTime / (60 * 1000)) % 60);
    var hours = Math.floor((remainingTime / (60 * 60 * 1000)) % 24);
    var days = Math.floor(remainingTime / (24 * 60 * 60 * 1000));

    thisTimerText = allcountDownTimers[i].getAttribute("data-textpre");

    if (days > 0) {
      thisTimerText += addLeadingZero(days) + ":";
    } else {
      thisTimerText += '';
    }
    thisTimerText += addLeadingZero(hours) + ":" + addLeadingZero(minutes) + ":" + addLeadingZero(seconds);
    thisTimerText += allcountDownTimers[i].getAttribute("data-textpost");
    if (thisTimerText != countDownTimers[i][2]) {
      // only access the DOM if the text has changed:
      countDownTimers[i][0].innerHTML = thisTimerText;
      countDownTimers[i][2] = thisTimerText;
    }

    if (remainingTime < 1) {


      countDownTimers[i][0].parentNode.innerHTML = '<p>' + allcountDownTimers[i].getAttribute("data-textcomplete") + '</p>';
      // remove this timer
      countDownTimers.splice(i, 1);
      i--;


    }
  }

  window.requestAnimationFrame(timerLoop);
}

if (document.getElementsByClassName('topMessageCountdown').length > 0) {
  var allcountDownTimers = document.getElementsByClassName('topMessageCountdown');
  for (var i = 0; i < allcountDownTimers.length; i++) {
    countDownTimers.push([allcountDownTimers[i], new Date().getTime() + (allcountDownTimers[i].dataset.seconds) * 1000, ""]);
  }
  timerLoop();
}